var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "margin-1 pega-table-sp" },
    [
      _c("h6", [_vm._v("■マッチング設定")]),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "個人プロフィール" } },
        [
          _c("job-content-table-outline", {
            attrs: { title: "性別", value: _vm.matching.gender },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "年齢", value: _vm.age },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "現住所", value: _vm.address },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "最終学歴", value: _vm.educationalBackground },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "卒業年月", value: _vm.graduate },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "学校名・学部名", "data-test": "educationSearch" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        "「学校名」「学部／学科名」から、フリーワード検索をおこないます。（200文字以内）"
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "pega-break",
                      domProps: {
                        textContent: _vm._s(
                          _vm.matching.educationalSearchWord || "未登録"
                        ),
                      },
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "pega-break",
                      domProps: {
                        textContent: _vm._s(
                          _vm.matching.educationSearchLabel || "未登録"
                        ),
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "学部・学科コード",
              value: _vm.educationDepartment,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline-sub", {
            attrs: { title: "現在の就業状況", contents: _vm.work },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "転居を伴う転職可否",
              value: _vm.matching.homeMoving,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "未既婚", value: _vm.matching.married },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "子供有無", value: _vm.matching.child },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "転職回数", value: _vm.matching.changeJobCount },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "経験職種・業種" } },
        [
          _c("job-content-table-outline-sub", {
            attrs: {
              title: "経験職種",
              contents: _vm.matching.experiencedOccupationList,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "経験業種", value: _vm.experiencedBusiness },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "語学力" } },
        [
          _c("job-content-table-outline", {
            attrs: { title: "TOEIC", value: _vm.toeic },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "TOEFL", value: _vm.toefl },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "英語スキル",
              value: _vm.matching.englishSkill.level,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: { title: "英語以外の語学スキル", value: _vm.otherLanguage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "スキルシート・資格" } },
        [
          _vm._l(_vm.skillsMaster, function (skillMaster) {
            return [
              _vm.hasChildCategorySkillBy(skillMaster.id)
                ? [
                    _c("job-content-table-outline-sub", {
                      key: skillMaster.id,
                      attrs: {
                        title: skillMaster.name,
                        contents: _vm.skill[skillMaster.id],
                      },
                    }),
                  ]
                : [
                    _c("job-content-table-outline", {
                      key: skillMaster.id,
                      attrs: {
                        title: skillMaster.name,
                        value: _vm.skill[skillMaster.id],
                      },
                    }),
                  ],
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "保有資格" } },
        [
          _c("job-content-table-outline", {
            attrs: { title: "保有資格", value: _vm.license },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "志向の指定" } },
        _vm._l(_vm.matching.workStyleList, function (workStyle, i) {
          return _c("job-content-table-outline", {
            key: "work-style-" + i,
            attrs: {
              title: workStyle.name,
              value: _vm.createJoinedText(workStyle.labelList),
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "希望の指定" } },
        [
          _c("job-content-table-outline-sub", {
            attrs: { title: "希望職種", contents: _vm.occupations },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "希望業種",
              value: _vm.createJoinedText(_vm.matching.desiredBusinessNameList),
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "希望勤務地",
              value: _vm.createJoinedText(_vm.matching.desiredWorkPlaceList),
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "希望雇用形態",
              value: _vm.createJoinedText(_vm.matching.desiredEmploymentList),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "フリーワード" } },
        [
          _c("job-content-table-outline", {
            attrs: { title: "フリーワード", "data-test": "freeWord" },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          「職務経歴内容」「保有資格」「その他の外国語」「自己PR」から、フリーワード検索をおこないます。（全角200文字以内）"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          ※上記項目に登録がない会員は検索対象外となります。また、他の設定条件との掛け合わせでキーワードによってはマッチング条件が厳しくなりすぎる恐れがあります。"
                      ),
                      _c("br"),
                      _vm._v("\n          キーワード（スペース区切り）:"),
                      _c("br"),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "pega-break",
                      domProps: {
                        textContent: _vm._s(_vm.matching.freeWord || "未登録"),
                      },
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "pega-break",
                      domProps: {
                        textContent: _vm._s(
                          _vm.matching.freeWordSearchLabel || "未登録"
                        ),
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "活動履歴の指定" } },
        [
          _c(
            "job-content-table-outline",
            {
              attrs: {
                title: "新規会員の指定",
                value: _vm.matching.registrationDate,
              },
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "※検索する求職者（女の転職type会員）の対象範囲を指定してください。"
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }